export const SURVEY_VALIDATION_ERROR_MESSAGE =
  'アンケートの入力内容を確認してください。'

export const getSurveyErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  const responseMessage = (
    error as { response?: { data?: { message?: string | string[] } } }
  )?.response?.data?.message

  if (Array.isArray(responseMessage)) {
    return responseMessage.length > 0
      ? SURVEY_VALIDATION_ERROR_MESSAGE
      : fallback
  }
  if (typeof responseMessage === 'string' && responseMessage.trim()) {
    return responseMessage
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message
  }
  return fallback
}
